export const tieredmenuTheme = {
  extend: {
    custom: {
      iconColor: "{text.color}",
      iconFocusColor: "{primary.700}",
      iconActiveColor: "{primary.700}",
    },
  },
  css: ({ dt }: { dt: (token: string) => string }) => `
    .p-tieredmenu.actionbutton-menu .p-tieredmenu-item-icon {
      color: ${dt("tieredmenu.custom.iconColor")};
    }
    .p-tieredmenu.actionbutton-menu .p-tieredmenu-item-content:hover .p-tieredmenu-item-icon,
    .p-tieredmenu.actionbutton-menu .p-tieredmenu-item-link:focus .p-tieredmenu-item-icon {
      color: ${dt("tieredmenu.custom.iconFocusColor")};
    }
    .p-tieredmenu.actionbutton-menu .p-tieredmenu-item-active > .p-tieredmenu-item-content .p-tieredmenu-item-icon {
      color: ${dt("tieredmenu.custom.iconActiveColor")};
    }
  `,
};
